__webpack_require__.p = "https://uk.knowledgesearchcore.thomsonreuters.com/";